<script>
   /*********************************************************
   * ScoresPlot                                             *
   * --------------------                                   *
   * shows plot for PCA scores                              *
   **********************************************************/

   import { mrange, range } from 'mdatools/stat';
   import { Vector } from 'mdatools/arrays';
   import { Axes, XAxis, YAxis, Segments, Box } from 'svelte-plots-basic/2d';
   import { pcares_get } from '../wasm/pcvpca';

   import PlotSeries from './PlotSeries.svelte';
   import AppLegend from './AppLegend.svelte';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let model;                // PCA model object
   export let pvoptions;            // object with PV-options
   export let params;               // JSON with main plot parameters
   export let res;                  // JSON with results

   const title = 'Scores (X)';
   const margins = [0.75, 1.0, 0.1, 0.5];
   const showGrid = true;

   function get_series(id, res, params) {
      return {
         id: id,
         x: new Vector(pcares_get(res, 'scores', params.comp[0])),
         y: new Vector(pcares_get(res, 'scores', params.comp[1]))
      };
   }

   // get score values
   $: ps = params && res ? Object.keys(res).map(id => get_series(id, res[id], params)) : null;

   // set axis labels
   $: xLabel = params && params.comp ? 'LV' + params.comp[0] : '';
   $: yLabel = params && params.comp ? 'LV' + params.comp[1] : '';

   // set limits
   $: limX = ps ? mrange(Object.keys(ps).map(id => range(ps[id].x.v)).flat()) : [0, 1];
   $: limY = ps ? mrange(Object.keys(ps).map(id => range(ps[id].y.v)).flat()) : [0, 1];
</script>

{#if params && model && pvoptions}
<Axes {margins} {xLabel} {yLabel} {limX} {limY} {title} >

   <Segments xStart={[limX[0]]} xEnd={[limX[1]]} yStart={[0]} yEnd={[0]} lineColor='#a0a0a0'/>
   <Segments yStart={[limY[0]]} yEnd={[limY[1]]} xStart={[0]} xEnd={[0]} lineColor='#a0a0a0'/>

   {#each ps as series}
   <PlotSeries values={series} type="p" />
   {/each}

   <AppLegend />
   <XAxis {showGrid} slot="xaxis" />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}